import React from "react";
import CountUp from "react-countup";
import TrackVisibility from "react-on-screen";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { slugify } from "../../utils";
import SplashData from "../../data/splash/SplashData.json";
import { useSelector } from "react-redux";
import { media_url } from "../../hooks/useBlog";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const DemoData = SplashData[0];

const CountData = [
  {
    id: 1,
    title: "Demo Website (More Coming)",
    count_num: "5",
  },
  {
    id: 2,
    title: "Inner Page",
    count_num: "30",
  },
  {
    id: 3,
    title: "Elements",
    count_num: "30",
  },
];
function SlickNextArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <FaAngleRight />
    </div>
  );
}

function SlickPrevArrow(props) {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <FaAngleLeft />
    </div>
  );
}

var slideSettings = {
  infinite: true,
  speed: 500,
  autoplaySpeed: 1500,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: false,
  centerMode: true,
  arrows: true,
  dots: false,
  swipeToSlide: false,
  draggable: false,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        variableWidth: false,
      },
    },
  ],
  nextArrow: <SlickNextArrow />,
  prevArrow: <SlickPrevArrow />,
};

// [
//     {
//         "id": 18,
//         "link": "https://alcaldiadeguacara.gob.ve",
//         "type": "link",
//         "image": "guacara/blog/post/2025/08/20/banner_alcalde_juramentacion.jpg",
//         "title": "NACE CON AMOR",
//         "enabled": true,
//         "promoted": false
//     },
//     {
//         "id": 17,
//         "link": "https://alcaldiadeguacara.gob.ve/guacara/",
//         "type": "link",
//         "image": "guacara/blog/post/2025/08/20/header_tinaquillo.jpg",
//         "title": "DOMINGOS DE RAMOS",
//         "enabled": true,
//         "promoted": false
//     },
//     {
//         "id": 16,
//         "link": "https://alcaldiadeguacara.gob.ve/guacara/",
//         "type": "link",
//         "image": "guacara/blog/post/2025/08/20/uniformes_servicios_publicos.jpeg",
//         "title": "LL",
//         "enabled": true,
//         "promoted": false
//     }
// ]
const SplashBanner = () => {
  const { banners } = useSelector((state) => state.blog);
  const isSmall = window.innerWidth < 768;
  const [viewState, setViewState] = React.useState({
    isSmall: isSmall,
    bannerWidth: "600px",
    bannerHeight: "300px",
  });
  const handleResize = () => {
    var width = window.innerWidth;
    // 600 / 1440 = 0.41666667
    var height = width * 0.41666667;
    setViewState({
      isSmall: width < 768,
      bannerWidth: width + "px",
      bannerHeight: height + "px",
    });
  };

  // add listener to window resize
  React.useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  React.useEffect(() => {
    handleResize();
  }, []);

  return (
    <div
      className="section splash-main-banner"
      style={{
        // maxWidth: '80%',
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      {/* <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">
                        <div className="banner-content">
                            <h1 className="title">Creative Agency, Corporate and Portfolio <span>React JS</span> Template + RTL</h1>
                            <div className="site-element-count">
                                {
                                    CountData.map((data) => (
                                        <div className="count-box" key={data.id}>
                                            <span className="count-title">{data.title}</span>
                                            <div className="count-number h2">
                                                <TrackVisibility once>
                                                        {({isVisible}) => (
                                                            <span className="number count">
                                                                {isVisible ? <CountUp end={data.count_num} duration={1} /> : null}
                                                            </span>
                                                        )}  
                                                </TrackVisibility>
                                                <span className="symbol">+</span>
                                            </div>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

      {banners && banners.length > 0 && (
        <div className="demo-slider">
          <Slider
            {...slideSettings}
            variableWidth={false}
            className="slick-arrow-nav"
            centerMode={true}
          >
            {/* {banners.map((banner) => (
              <div className="single-slide" key={banner.id}>
                <Link to={banner.link} target="_blank" rel="noreferrer">
                  <img src={media_url(banner.image)} alt={banner.title} />
                </Link>
              </div>
            ))} */}
            {banners.map((banner, index) => (
              // relation 1440x600 is  80vw x 30vh
              <div
                className=""
                key={index}
                style={{
                  outline: "none",
                  textAlign: "center",
                  margin: "0 auto",
                  width: "100%",
                  height: viewState.bannerHeight + " !important",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    // padding: isSmall ? "0 10px" : "0 30px",
                    backgroundImage: `url(${media_url(banner.image)})`,
                    height: viewState.bannerHeight,
                    width: viewState.bannerWidth,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "8px",
                    margin: "0 auto",
                    cursor: "pointer",
                  }}
                  onClick={() => window.open(banner.link, "_blank")}
                ></div>
              </div>
            ))}
          </Slider>
        </div>
      )}
      {/* <div className="demo-slider">
                <Slider {...slideSettings} className="slick-dot-nav">
                 
                    {DemoData.slice(0, 5).map((data) => (
                        <div className="single-slide" key={data.id}>
                            <Link to={`${process.env.PUBLIC_URL}/${slugify(data.title)}`}>
                                <img src={`${process.env.PUBLIC_URL}${data.width_img}`} alt="Demo" />
                            </Link>
                        </div>
                    ))}
                </Slider> 
            </div> */}

      {/* <ul className="list-unstyled shape-group-20">
                <li className="shape shape-1">
                <img src={process.env.PUBLIC_URL + "/images/others/bubble-12.png"} alt="Bubble" />
                </li>
                <li className="shape shape-4">
                <img src={process.env.PUBLIC_URL + "/images/others/bubble-14.png"} alt="Bubble" />
                </li>
                <li className="shape shape-5">
                <img src={process.env.PUBLIC_URL + "/images/others/bubble-37.png"} alt="Bubble" />
                </li>
                <li className="shape shape-7">
                <img src={process.env.PUBLIC_URL + "/images/others/bubble-31.png"} alt="Bubble" />
                </li>
            </ul> */}
    </div>
  );
};

export default SplashBanner;
